.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 40px 20px;
  text-align: center;
}

/* In a table or a small panel: room enough to read as a place that was designed to be empty, not a
   row that failed to load. */
.compact {
  padding: 36px 16px 40px;
}

.badge {
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  margin-bottom: 4px;
  border: 1px solid var(--accent-line);
  border-radius: var(--radius-lg);
  background: var(--accent-w);
  color: var(--accent);
}

.compact .badge {
  width: 38px;
  height: 38px;
}

.title {
  margin: 0;
  color: var(--ink);
  font-size: var(--t-head);
  font-weight: 650;
}

.body {
  max-width: 46ch;
  color: var(--muted);
  font-size: var(--t-body);
  line-height: 1.5;
}

.action {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}
